module.exports = __webpack_public_path__ + "img/code-1.c1cc54d3.png";